import DashboardService from '@/services/DashboardService-porsche'

export default {
  methods: {

    calculateDelta(act, prev) {
      if (!act || !prev) { return 0; }
      if (!act.Result || !prev.Result) { return 0; }
      return act.Result - prev.Result;
    },

    getPreviousWaveName(kpi) {
      if (!kpi || !kpi.SurveyWave) { return '-'; }
      let wave = _.first(kpi.SurveyWave);
      if (!wave) { return '-'; }
      return wave.Name;
    },

    getCurrentWaveName(kpi) {
      if (!kpi || !kpi.SurveyWave) { return '-'; }
      let wave = _.last(kpi.SurveyWave);
      if (!wave) { return '-'; }
      return wave.Name;
    },

    getNiceClientLocationName(rawName) {
      if (rawName.includes('Stuttgart')) { return 'Porsche Museum Stuttgart'; }
      if (rawName.includes('Berlin')) { return 'Porsche Zentrum Berlin'; }
      if (rawName.includes('Rotkreuz')) { return 'Porsche Drive Rotkreuz'; }
      if (rawName.includes('Genf')) { return 'Porsche Drive Genf'; }

      if (rawName.indexOf(' ') >= 0) {
        return rawName.substring(rawName.indexOf(' ') + 1);
      } else if (rawName.indexOf('^') >= 0) {
        return rawName.substring(rawName.indexOf('^') + 1);;
      } else {
        return rawName;
      }
    },

    getMatchingItem(selected, options, index) {
      let loc = selected[index-1];
      var item = _.find(options, [ 'id', loc ]);
      if (!item) {
        item = { 'id': loc, 'label': loc };
      }
      return item;
    },

    addTotals(raw, selected, options, result) {

      result.OverallByWave = raw[0].data.OverallByWave;

      let totalKpi = {
        KpiCode: undefined,
        Weighting: undefined,
        KpiGroupCode: undefined,
        KpiName: undefined,
        KpiCodeParent: undefined,
        SurveyWave: [],
        entries: [],
        Diff: 0,
        Delta: 0
      };

      // 1st item is only for total values
      for (let i = 1; i < raw.length; i++){

        var match = this.getMatchingItem(selected, options, i);
        var modLabel = this.getNiceClientLocationName(match.label);

        let oldtotal = this.addTotalIfExists(raw[i].data.OverallByWave);
        if (!totalKpi.KpiCode) { totalKpi.KpiCode = oldtotal.KpiCode; }
        if (!totalKpi.Weighting) { totalKpi.Weighting = oldtotal.Weighting; }
        if (!totalKpi.KpiGroupCode) { totalKpi.KpiGroupCode = oldtotal.KpiGroupCode; }
        if (!totalKpi.KpiName) { totalKpi.KpiName = oldtotal.KpiName; }
        if (!totalKpi.KpiCodeParent) { totalKpi.KpiCodeParent = oldtotal.KpiCodeParent; }

        // Add entry with Name of Location/country
        let sub = _.last(oldtotal.SurveyWave);
        let subitem = {
          Name: modLabel,
          NumberOfShopsTotal: sub.NumberOfShopsTotal,
          Result: sub.Result,
          Delta: this.calculateDelta(_.last(oldtotal.SurveyWave), _.first(oldtotal.SurveyWave))
        };
        totalKpi.entries.push(subitem);
      }

      result.list.push(totalKpi);
    },

    initDashdataMultipleResults2 (raw, context, selected, options) {
      let result = { list : [] };
      if (_.isEmpty(raw) || _.isEmpty(raw[0].data.KPI)) {
        return null;
      }

      this.addTotals(raw, selected, options, result);

      // 1st item is only for total values
      for (let i = 1; i < raw.length; i++){
        raw[i].data.KPI.forEach(kpi => {
          if (kpi.KpiCode === 'General Information' || kpi.KpiCode === 'Statistics') {
            return;
          }

          var match = this.getMatchingItem(selected, options, i);
          var modLabel = this.getNiceClientLocationName(match.label);

          var item = _.find(result.list, ['KpiCode', kpi.KpiCode]);
          if (!item) {
            item = {
              KpiCode: kpi.KpiCode,
              Weighting: 'N/A',
              KpiGroupCode: kpi.KpiGroupCode,
              KpiName: kpi.KpiName,
              SurveyWave: kpi.SurveyWave,
              entries: [],
              KpiCodeParent: '0',
              Diff: 0
            };
            result.list.push(item);
          }

          // Add entry with Name of Location/country
          let sub = _.last(kpi.SurveyWave);
          let subitem = {
            Name: modLabel,
            NumberOfShopsTotal: sub.NumberOfShopsTotal,
            Result: sub.Result,
            Delta: 0
          };
          item.entries.push(subitem);
        });
      }

      // 2nd append Questions
      for (let i = 1; i < raw.length; i++) {

        var match = this.getMatchingItem(selected, options, i);
        var modLabel = this.getNiceClientLocationName(match.label);

        raw[i].data.Question.forEach(q => {
          if (q.KpiCode === 'General Information' || q.KpiCode === 'Statistics') {
            return;
          }

          var question = _.find(result.list, ['KpiName', q.QuestionText]);
          if (!question) {
            question = {
              KpiCode: q.QuestionCode,
              KpiGroupCode: q.KpiGroupCode,
              KpiName: q.QuestionText,
              SurveyWave: q.SurveyWave,
              entries: [],
              KpiCodeParent: q.KpiCode,
            };
            result.list.push(question);
          }

          // Add entry with Name of Location/country
          let sub = _.last(q.SurveyWave);
          let subitem = {
            Name: modLabel,
            NumberOfShopsTotal: sub.NumberOfShopsTotal,
            Result: sub.Result,
            Delta: 0
          };
          question.entries.push(subitem);
        });
      }

      // Dealer distribution
      let wavenames = [];
      raw[0].data.dealerdistribution.forEach(dd => {
        if (dd.waves) {
          dd.waves.forEach(w => {
            wavenames.push(w.name);
          });
        }
      });
      result.wavenames = _.sortedUniq(_.uniq(wavenames));

      return result;
    },

    appendKpi(result, raw, selected, options, i) {
      var match = this.getMatchingItem(selected, options, i);
      var modLabel = this.getNiceClientLocationName(match.label);

      raw[i].data.KPI.forEach(kpi => {

        let item = {
          KpiCode: kpi.KpiCode + match.id,
          Weighting: 'N/A',
          KpiGroupCode: kpi.KpiGroupCode,
          KpiName: kpi.KpiName + ' - ' + modLabel,
          SurveyWave: kpi.SurveyWave,
          KpiCodeParent: '0',
          Diff: this.calculateDelta(_.last(kpi.SurveyWave), _.first(kpi.SurveyWave))
        };

        if (kpi.KpiCode !== 'General Information' && kpi.KpiCode !== 'Statistics') {
          result.list.push(item);
        }
      });
    },

    initDashdataMultipleResults(raw, context, selected, options) {
      return this.initDashdataMultipleResults2(raw, context, selected, options);

      let result = { list : [] };
      if (_.isEmpty(raw) || _.isEmpty(raw[0].data.KPI)) {
        return null;
      }

      result.OverallByWave = raw[0].data.OverallByWave;
      let total = this.addTotalIfExists(result.OverallByWave );
      if (total) { result.list.push(total); }

      // 1st item is only for total values
      for (let i = 1; i < raw.length; i++){
        this.appendKpi(result, raw, selected, options, i);
      }

      // 2nd append Questions
      for (let i = 1; i < raw.length; i++){
        var match = this.getMatchingItem(selected, options, i);
        raw[i].data.Question.forEach(q => {

          let item = {
            KpiCode: q.QuestionCode + match.id,
            KpiGroupCode: q.KpiGroupCode,
            KpiName: q.QuestionText,
            SurveyWave: q.SurveyWave,
            KpiCodeParent: q.KpiCode + match.id,
            Diff: this.calculateDelta(_.last(q.SurveyWave), _.first(q.SurveyWave))
          };

          if (q.KpiCode !== 'General Information' && q.KpiCode !== 'Statistics') {
            result.list.push(item);
          }

        });
      }

      // Dealer distribution
      let wavenames = [];
      raw[0].data.dealerdistribution.forEach(dd => {
        if (dd.waves) {
          dd.waves.forEach(w => {
            wavenames.push(w.name);
          });
        }
      });
      result.wavenames = _.sortedUniq(_.uniq(wavenames));

      return result;
    },

    addTotalIfExists(overalls) {
      if (!_.isEmpty(overalls)) {
        let overall = overalls[0];
        let total = {
          KpiCode: overall.KpiCode,
          Weighting: '',
          KpiGroupCode: 'overall.KpiGroupCode',
          KpiName: 'Total Index',
          SurveyWave: overall.SurveyWave,
          KpiCodeParent: '0',
          Diff: this.calculateDelta(_.last(overall.SurveyWave), _.first(overall.SurveyWave)),
          Delta: this.calculateDelta(_.last(overall.SurveyWave), _.first(overall.SurveyWave))
        };

        if (!total.SurveyWave) {
          total.SurveyWave = [];
        }
        return total;
      }
    },


    initDashdata(raw) {
      raw.list = [];

      if (_.isEmpty(raw.KPI)) {
        return null;
      }

      if (!_.isEmpty(raw.OverallByWave)) {
        let overall = raw.OverallByWave[0];
        let total = {
          KpiCode: overall.KpiCode,
          Weighting: '',
          KpiGroupCode: 'overall.KpiGroupCode',
          KpiName: 'Total Index',
          SurveyWave: overall.SurveyWave,
          KpiCodeParent: '0',
          Diff: this.calculateDelta(_.last(overall.SurveyWave), _.first(overall.SurveyWave))
        };

        if (!total.SurveyWave) {
          total.SurveyWave = [];
        }

        raw.list.push(total);
      }

      raw.KPI.forEach(kpi => {
        let item = {
          KpiCode: kpi.KpiCode,
          Weighting: 'N/A',
          KpiGroupCode: kpi.KpiGroupCode,
          KpiName: kpi.KpiName,
          SurveyWave: kpi.SurveyWave,
          KpiCodeParent: '0',
          Diff: this.calculateDelta(_.last(kpi.SurveyWave), _.first(kpi.SurveyWave))
        };
        if (kpi.KpiCode !== 'General Information' && kpi.KpiCode !== 'Statistics') {
          raw.list.push(item);
        }
      });

      if (!_.isEmpty(raw.Question)) {
        raw.Question.forEach(q => {
          let item = {
            KpiCode: q.QuestionCode,
            KpiGroupCode: q.KpiGroupCode,
            KpiName: q.QuestionText,
            SurveyWave: q.SurveyWave,
            KpiCodeParent: q.KpiCode,
            Diff: this.calculateDelta(_.last(q.SurveyWave), _.first(q.SurveyWave))
          };
          if (q.KpiCode !== 'General Information' && q.KpiCode !== 'Statistics') {
            raw.list.push(item);
          }
        });
      }


      // fixes for marketcompare
      if (!_.isEmpty(raw.marketcompare)) {
        raw.marketcompare[0].series[0].color = '#AAA';
        raw.marketcompare[0].series[1].color = '#777';

        raw.marketcompare[0].series.forEach(mc => {
          if (mc.name == 'Total Index Market') {
            mc.name = 'Selection - Total Index';
          }
        });
      }

      // Dealer distribution
      let wavenames = [];
      raw.dealerdistribution.forEach(dd => {
        if (dd.waves) {
          dd.waves.forEach(w => {
            wavenames.push(w.name);
          });
        }
      });
      raw.wavenames = _.sortedUniq(_.uniq(wavenames));

      raw.dealerdistribution.forEach(dd => {
        dd.name = dd.min + '-' + dd.max + '%';

        if (!dd.waves) {
          dd.lastwave = 0;
          dd.actualwave = 0;
        } else {
          if (dd.waves.length === 1) {
            if (raw.wavenames.length > 1) {
              let idx = _.indexOf(raw.wavenames, dd.waves[0].name);
              if (idx === 0) {
                dd.lastwave = dd.waves[0].Result;
                dd.actualwave = 0;
              } else {
                dd.lastwave = 0;
                dd.actualwave = dd.waves[0].Result;
              }
            } else {
              dd.lastwave = 0;
              dd.actualwave = dd.waves[0].Result;
            }
          } else {
            dd.lastwave = dd.waves[dd.waves.length - 2].Result;
            dd.actualwave =  _.last(dd.waves).Result;
          }
        }
      });

      return raw;
    },

    handleRejection(p) {
        return p.catch(err=> ({ error: err }));
    },

    async getDashboardMultipleCallsClientLocations(filter, cancelToken, clientLocations) {
      let calls = [];

      // 1st call to get proper overall / total results
      calls.push(DashboardService.getDashboard(filter, cancelToken));
      var filterBackup = filter.clientlocations;

      // For each selected item
      clientLocations.forEach(cl => {
       filter.clientlocations = cl;
        calls.push(DashboardService.getDashboard(filter, cancelToken));
      });

      filter.clientlocations = filterBackup;
      return await Promise.all(calls.map(this.handleRejection));
    },

    async getDashboardMultipleCallsCountries(filter, cancelToken, countries) {
      let calls = [];
      var filterBackup = filter.countries;
      filter.countries = "";
      // 1st call to get proper overall / total results
      calls.push(DashboardService.getDashboard(filter, cancelToken));

      // For each selected item
      countries.forEach(cl => {
        filter.countries = cl;
        calls.push(DashboardService.getDashboard(filter, cancelToken));
      });

      filter.countries = filterBackup;
      return await Promise.all(calls.map(this.handleRejection));
    },


  }
}
